import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, of, map, switchMap } from "rxjs";
import { AuthenticationService } from "./authentication.service";
import { LoaderService } from "./loader.service";
import { ActionResult, UserDetail } from "@model";
import { EnvironmentService } from "./environment.service";

@Injectable({ providedIn: 'root' })
export class UserDetailService {
  private _currentUserDetails = new BehaviorSubject<UserDetail | undefined>(undefined);

  get currentUserDetails() {
    return this._currentUserDetails;
  }

  constructor(
    private http: HttpClient,
    private authService: AuthenticationService,
    private loaderService: LoaderService,
    private environmentService: EnvironmentService
  ) {}

  fetchUserProfile(onSuccess?: (userDetails: UserDetail | undefined) => void): void {
    this.http.post<ActionResult<UserDetail>>(this.environmentService.getApiUrl() + "/api/user/userprofile", {}).subscribe(actionResult => {
      this.currentUserDetails.next(actionResult.result);
      if (onSuccess) {
        onSuccess(actionResult.result)
      }
    });
  }


    fetchCurrentUserDetails(ignoreCache = false): Observable<UserDetail | undefined> {
        const cached = !!this.currentUserDetails.value?.id;
        if (cached && !ignoreCache) {
            return of(this.currentUserDetails.value);
        }

        return this.http
            .post<ActionResult<UserDetail>>(
                this.environmentService.getApiUrl() + "/api/user/userprofile",
                {}
            )
            .pipe(
                map(actionResult => {
                    const result = actionResult.result ?? undefined;
                    this.currentUserDetails.next(result);
                    return result;
                })
            );
    }

    updateUserProfile(userDetails: UserDetail): Observable<UserDetail | undefined> {
        return this.http.post<ActionResult<boolean>>(
                this.environmentService.getApiUrl() + "/api/user/userprofile/update",
                userDetails
            )
            .pipe(
                switchMap(actionResult => {
                    if (actionResult.success) {
                        return this.fetchCurrentUserDetails(true);
                    }
                    return of(undefined);
                }),
            );
    }


  emptyCurrentUserDetails(): void {
    this.currentUserDetails.next(undefined);
  }
}
